import React from 'react';
import { Link } from 'react-router-dom';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class DropdownProfile extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            userName: JSON.parse(localStorage.getItem('user')).name
        };
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render() {

        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="dropdown navbar-user g-cursor-pointer" tag="li">
                <DropdownToggle className="dropdown-toggle" tag="a">
                    <div className="image image-icon bg-black text-grey-darker">
                        <i className="fa fa-user"></i>
                    </div>
                    <span className="d-none d-md-inline">{this.state.userName}</span> <b className="caret"></b>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu dropdown-menu-right" tag="ul">
                    {/*
                    <DropdownItem>Edit Profile</DropdownItem>
                    <DropdownItem><span className="badge badge-danger pull-right">0</span> Inbox</DropdownItem>
                    <DropdownItem>Calendar</DropdownItem>
                    <DropdownItem>Setting</DropdownItem>
                    <div className="dropdown-divider"></div>
                    */}
                    <DropdownItem className="text-center p-t-5 p-b-5">
                        <Link to="/logout" className="text-black-lighter text-center">로그 아웃</Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    }
};

export default DropdownProfile;



// WEBPACK FOOTER //
// ./src/components/admin/header/dropdown/profile.js